import React from 'react';
import FakeData from '.././fake-data';
import ReactDOM from 'react-dom';
import { Link, Redirect } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './PostView.css'
import { LeagueSplitView, BannerShimmer, ItemPicker, LoadingState, Modal, ComboBox, CommentInputBox, SharedPostItem, ShareContent, ConfirmModal, PostItem } from '.././components/Common';
import { CommentCollection } from '.././components/GAME';
import EmojiPicker from '.././components/EmojiPicker';
import { EmbedMaterial } from '../components/Training';

const Trojan = window.Trojan;
const Croppie = window.Croppie;
const $ = window.$;
const jQuery = window.jQuery;
const dummyVid = "http://clips.vorwaerts-gmbh.de/VfE_html5.mp4";


export default class PostView extends React.Component {
    constructor(p) {
        super(p)
        this.state = {
            error: false,
            post: {
                id: null,
                media: [
                    {
                        id: 0,
                        url: "server/media/59805d73eb8da.jpg",
                        type: "image"
                    },
                    {
                        id: 1,
                        url: dummyVid,
                        type: "video"
                    }, {
                        id: 0,
                        url: "server/media/59805d73eb8da.jpg",
                        type: "image"
                    },
                    {
                        id: 1,
                        url: dummyVid,
                        type: "video"
                    }
                ]
            },
            offset: 70,
            isShowingComments: false,
            isEditting: false,
            content: "",
            value: "",
            media: {},
            file: {},
            activeMedia: 0,
            ownerOpts: [1, 2, 3, 74, 5, 6],
            isFocused: false,
            isLoading: true,
            isSharing: false,
            isDeleting: false
        }

        this.onScroll = this.onScroll.bind(this)
        this.onKeyDown = this.onKeyDown.bind(this)
    }

    componentWillMount() {
        const s = new Trojan.style("league").kill()
        var params = FakeData.getQueries(this.props.location.search);
        this.setState({ activeTab: (params.sInit) ? params.sInit : "about" });

    }

    componentWillUnmount() {
        const s = new Trojan.style("league").kill()
        this._isMounted = false;
        FakeData.mountState("post", false)
        document.querySelector("#root").removeEventListener('scroll', this.onScroll);
    }

    componentDidMount() {
        FakeData.mountState("post", true)
        this._isMounted = true;
        window.addEventListener('scroll', this.onScroll);
        this.getPost();
        document.querySelector("#root").addEventListener('scroll', this.onScroll);
        document.addEventListener("keydown", this.onKeyDown)
        //console.log(this.props)
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.match.params.id !== nextProps.match.params.id || this.props.location.search !== nextProps.location.search) {
            const _that = this
            FakeData.mountState("post", false)
            this.setState({
                post: { id: null }
            });
            const s = new Trojan.style("league").kill()

            setTimeout((() => {
                FakeData.mountState("post", true)

            }), 1000)

            return true;
        }

        if (this.props.location.search !== nextProps.location.search) {
            var params = FakeData.getQueries(nextProps.location.search);
            this.setState({ params: params });
        }

        return true
    }

    getPost = () => {
        const _that = this;
        const data = {
            type: this.props.match.params.type,
            id: this.props.match.params.id,
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            }
        }

        //console.log(data)

        FakeData.post("/getPost.php?auth0&min", data, {
            success(res) {
                if (!_that._isMounted) {
                    return;
                }

                if (res === null) {
                    _that.setState({ error: true, isLoading: false });
                } else {
                    _that.setState({ post: res, isLoading: false });
                    setTimeout(() => {
                        //_that.getPost()
                    }, 1000)
                }
            },
            error(e) {
                _that.setState({ error: true, isLoading: false });
            }
        })
    }

    onKeyDown(e) {
        //console.log(e)
        const { isFocused } = this.state
        if (!isFocused) {
            return;
        }
        if (e.keyCode === 37) {
            if ((this.state.activeMedia - 1) < 0) {
                return
            }

            this.setState({ activeMedia: this.state.activeMedia - 1 });
        } else if (e.keyCode === 39) {
            if ((this.state.activeMedia + 1) >= this.state.post.media.length) {
                return
            }

            this.setState({ activeMedia: this.state.activeMedia + 1 });
        }
    }

    onScroll(e) {
        this.setState({
            offset: document.querySelector("#root").scrollTop
        });
    }

    like() {
        const dataTo = {
            user: FakeData.getData("yoo"),
            type: this.state.post.commentType,
            contentId: this.state.post.id,
            userOne: this.state.post.user,
            userTwo: this.state.post.userTo,
            users: this.state.post.tags,
            userType: (this.state.post.isAdmin) ? this.state.post.user.type : "F"
        }
        const _that = this

        FakeData.post('/likeContent.php?auth0', dataTo, {
            success: ((res) => {

            }),
            error: ((err) => {

            })
        })
    }

    editPost() {
        const _that = this
        const dataTo = {
            postId: this.state.post.id,
            content: this.state.content
        }

        FakeData.post("/editPost.php?auth0", dataTo, {
            success: ((res) => {
                _that.setState({
                    isEditting: false
                });
            }),
            error: ((err) => {

            })
        })
    }

    deletePost() {
        const _that = this
        const dataTo = {
            postId: this.state.post.id,
            media: this.props.post.media
        }

        FakeData.post("/deletePost.php?auth0", dataTo, {
            success: ((res) => {

            }),
            error: ((err) => {

            })
        })
    }

    onEnter(e, id, cb) {
        const dataTo = {
            postId: id,
            content: e,
            type: this.state.post.commentType,
            media: this.state.media,
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userOne: this.state.post.user,
            userTwo: this.state.post.userTo,
            users: this.state.post.users,
            userType: this.state.userType
        }

        const _that = this

        FakeData.post('/createComment.php?auth0', dataTo, {
            success: ((res) => {
                _that.setState({
                    value: "",
                    media: {},
                    file: {}
                });
                cb.call(this)
            }),
            error: ((err) => {
                cb.call(this)
            })
        })
    }

    onFilePicked(file) {
        const _that = this
        let reader = new FileReader()
        reader.onloadend = () => {
            const newFile = {
                file: file,
                progress: 0,
                url: reader.result
            }

            _that.setState({
                file: newFile
            });

            _that.uploadFile(newFile)
        }
        reader.readAsDataURL(file)
    }

    uploadFile(file) {
        var formdata = new FormData();
        const _that = this
        formdata.append("file", file.file);
        formdata.append("location", "");
        formdata.append("albumId", 0);
        formdata.append("tags", "")
        formdata.append("toId", FakeData.getData("yoo").id);
        var ajax = new XMLHttpRequest();
        ajax.upload.addEventListener("progress", (e) => {
            let percent = Math.round((e.loaded / e.total) * 100);
            _that.state.file.progress = percent
            _that.setState({
                file: _that.state.file
            });
        }, false);
        ajax.addEventListener("load", (e) => {
            let data = JSON.parse(e.target.responseText)
            data.oldUrl = file.url
            _that.setState({
                media: data
            });
        }, false);
        ajax.open("POST", FakeData.URL + "/uploadMedia.php?auth0&userId=" + FakeData.getData("yoo").id);
        ajax.send(formdata);

    }

    deleteMedia() {
        const file = this.state.media
        const _that = this
        const dataTo = {
            userId: FakeData.getData("yoo").id,
            img: file,
            tags: this.state.tags
        }

        FakeData.post("/removeMedia.php?auth0", dataTo, {
            success: ((res) => {
                _that.setState({
                    media: {},
                    file: {}
                });
            }),
            error: ((err) => {

            })
        }, true, "File Was Removed", ((res) => {

        }))
    }

    shareNow = () => {
        this.refs.share.blur()
        const _that = this;
        const data = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            content: "",
            coord: { lat: 0, lng: 0 },
            audience: "friends",
            type: "POST",
            post: this.props.post,
            postType: "normal",
            place: { name: "" },
            tagged: []
        }

        FakeData.post("/sharePost.php?auth0", data, {
            success(res) {
                FakeData.alert("Post shared on your timeline!");
            },
            error(err) {

            }
        }, true, "", () => { })
    }

    getUser = (pUser, oUser) => {
        if (pUser.admin && pUser.admin.id === oUser.id) {
            return pUser;
        } else {
            const i = FakeData.listify(pUser.roles).findIndex(
                data => data.user.id == oUser.id
            );
            if (i === -1) {
                return oUser;
            } else {
                return pUser;
            }
        }
    };

    render() {
        const User = FakeData.getData("yoo");
        const item = this.state.post;
        const { isDeleting, isEditting, isSharing } = this.state;
        if (this.state.isLoading) {
            return (
                <BannerShimmer />
            );
        }

        if (this.state.error) {
            return (
                <Redirect to={{
                    pathname: "/404",
                    state: { from: this.props.location }
                }} />
            )
        }

        return (
            <div className="post-viewer sp-flex-width" ref={(r) => {
                this.mediaElem = (r === null) ? this.mediaElem : r
            }} tabIndex={0} style={{ zIndex:0 }}>
                <Helmet>
                    <title>{"Post - Supotsu"}</title>
                </Helmet>
                <LeagueSplitView isPostView={true} isUser={true} class="league" offset={this.state.offset}>
                    {this.is &&
                        <div className="post-viewer-content posts">
                        <div className="post-viewer-content post">
                            <div className="post-viewer-content-header">
                                <img src="server/media/59805d73eb8da.jpg" className="post-viewer-content-avatar" alt="Commentor Avatar" />
                                <div className="post-viewer-content-author">
                                    <h1><Link to={{
                                        pathname: (
                                            (item.user.type === "F" || item.user.type === "P") ? "/profile/" + item.user.user :
                                                (item.user.type === "L") ? "/tournament/" + item.user.user :
                                                    (item.user.type === "C") ? "/club/" + item.user.user :
                                                        (item.user.type === "I") ? "/institution/" + item.user.user :
                                                            "/team/" + item.user.id
                                        ), search: "?sInit=about"
                                    }}>{item.user.name}</Link></h1>
                                    <p>
                                        <span>{window.moment(item.timeAgo).calendar()}</span>
                                    </p>
                                </div>
                                {(item.sport.image !== "images/" && !item.isShared) &&
                                    <div className="post-viewer-content-label" style={{ background: item.sport.color }}>
                                        <a title="Selected Sport">
                                            <div className="selected_btn rugby">
                                                <img src={item.sport.image} />
                                            </div></a>
                                        <div className="selected_sport">
                                            <a title="Selected Sport">{item.sport.name}</a>
                                        </div>
                                    </div>
                                }
                                <div className="post-viewer-content-options" tabIndex={0} ref={(ref) => {
                                    this.element = (ref === null) ? this.element : ref
                                }}>
                                    <i className="material-icons">keyboard_arrow_down</i>
                                    <div className="post-viewer-content-options-content">
                                        {
                                            this.state.ownerOpts.map((item, i) => {
                                                return (
                                                    <span key={i} className="post-viewer-content-options-content-item" onClick={() => this.element.blur()}>
                                                        <i className="material-icons">edit</i>
                                                        Edit
                                                    </span>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="post-body photo-container" tabIndex={0} onFocus={() => this.setState({ isFocused: true })} onBlur={() => this.setState({ isFocused: false })}>
                                <PostText className="post-caption" text={item.content} />
                                {(item.media.length > 0 && !item.isShared) &&
                                    <div className="post-viewer-content-media">

                                        {this.state.post.media.length > 1 &&
                                            <div className="post-viewer-content-media-controller" onClick={() => {
                                                if ((this.state.activeMedia - 1) < 0) {
                                                    return
                                                }

                                                this.setState({ activeMedia: this.state.activeMedia - 1 });
                                            }}>
                                                <img src="images/down_arrow_wht.svg" />
                                            </div>
                                        }
                                        <div className="post-viewer-content-media-contents">
                                            {
                                                this.state.post.media.map((item, i) => {
                                                    if (item.type === "video") {
                                                        return (
                                                            <video key={i} controls src={item.url} className={(i === this.state.activeMedia) ? "active" : ""}></video>
                                                        )
                                                    } else {
                                                        return (
                                                            <img key={i} src={item.url} className={(i === this.state.activeMedia) ? "active" : ""} />
                                                        )
                                                    }
                                                })
                                            }
                                        </div>
                                        {this.state.post.media.length > 1 &&
                                            <div className="post-viewer-content-media-controller" onClick={() => {
                                                if ((this.state.activeMedia + 1) >= this.state.post.media.length) {
                                                    return
                                                }

                                                this.setState({ activeMedia: this.state.activeMedia + 1 });
                                            }}>
                                                <img src="images/down_arrow_wht.svg" />
                                            </div>
                                        }

                                    </div>
                                }
                                {(item.isShared && item.shareType === "POST") &&
                                    <div className={"share-content-body-obj"}>
                                        <div className={"posts"}>
                                            <SharedPostItem hideSportLabel={false} style={{}} user={this.props.user} userType={this.props.userType} post={item.sharedObject} />
                                        </div>
                                    </div>
                                }
                                {(item.isShared && item.shareType === "SESSIONFILE") &&
                                    <div className={"share-content-body-obj"}>
                                        <EmbedMaterial isFile={true} file={item.sharedObject} />
                                    </div>
                                }
                                {(item.isShared && item.shareType === "SESSION") &&
                                    <div className={"share-content-body-obj"}>
                                        <EmbedMaterial isFile={false} session={item.sharedObject} />
                                    </div>
                                }
                            </div>
                            <div className="post-actions">
                                <div className="post-action like" onClick={() => this.like()}><i className="material-icons">thumb_up</i><span className="action-label">{FakeData.shortDigit(item.likes.length, "Like").data}</span></div>
                                <div className="post-action comment"><i className="material-icons">chat_bubble</i><span className="action-label">{FakeData.shortDigit(item.comments.length, "Comment").data}</span></div>
                                {item.commentType === "post" &&
                                    <div className="post-action share share-ctx" ref={"share"} tabIndex={0}>
                                        <i className="material-icons" style={{ transform: "rotateY(-180deg)" }}>reply</i>
                                        <span className="action-label">{FakeData.shortDigit(item.shares.length, "Share").data}</span>
                                        <div className="share-ctx-menu">
                                            <span onClick={this.shareNow.bind(this)}>Share Now</span>
                                            <span onClick={() => {
                                                this.setState({ isSharing: true })
                                                this.refs.share.blur()
                                            }}>Share With...</span>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="body-comments">
                                <CommentCollection user={FakeData.getData("yoo")} comments={item.comments} />
                                {this.state.file.url &&
                                    <div className="img-preload">
                                        <img src={this.state.file.url} />
                                        {(this.state.file.progress <= 99) &&
                                            <div className="img-preload-spinner"></div>
                                        }
                                        {(this.state.file.progress >= 99) &&
                                            <i className="img-preload-delete material-icons" onClick={() => this.deleteMedia()}>delete</i>
                                        }
                                    </div>
                                }
                                {this.isView &&
                                    <div className="body-comment-input">
                                        <img src={User.image} />
                                        <textarea placeholder="Write something.." onKeyUp={(e) => this.onEnter(e, item.id)} value={this.state.value} onChange={(e) => this.setState({
                                            value: e.target.value
                                        })} />
                                        <i className="material-icons">camera_alt<input type="file" accept="image/*" onChange={(e) => this.onFilePicked(e.target.files[0])} multiple="false" style={{ position: "absolute", margin: "-35px 0px 0px -10px", height: "30px", width: "30px", opacity: 0 }} /></i>
                                    </div>
                                }
                                <div className="body-comment-input">
                                    <img src={User.image} />
                                    <textarea />
                                    <i className="material-icons">camera_alt<input type="file" accept="image/*" onChange={(e) => this.onFilePicked(e.target.files[0])} multiple="false" style={{ position: "absolute", margin: "-35px 0px 0px -10px", height: "30px", width: "30px", opacity: 0 }} /></i>
                                </div>
                            </div>
                        </div>
                        </div>
                    }
                    <div className="posts" ref={(r)=>{
                        if(r){
                            //r.style.minHeight = "auto !important"
                            r.setAttribute('style', 'min-height:auto !important');
                        }
                    }} style={{
                        minHeight: "auto !important"
                    }}>
                        <PostItem 
                            key={"post-" + item.id}
                            isView={true}
                            words={[]}
                            hideSportLabel={false}
                            style={{}}
                            post={item}
                            key={"post_" + item.id}
                            user={
                            item.user.type !== "F" || item.user.type !== "P"
                                ? this.getUser(item.user, this.props.user)
                                : this.props.user
                            }
                            userType={
                            item.user.type !== "F" || item.user.type !== "P"
                                ? this.getUser(item.user, this.props.user).type
                                : this.props.userType
                            }
                        />
                    </div>
                    {isDeleting &&
                        <ConfirmModal message="Are you sure you want to remove this post?<br/>" isOpen={isDeleting} data={""}
                            onOkay={(data) => {
                                this.deletePost()
                            }}
                            onCancel={() => {
                                this.setState({
                                    isDeleting: false
                                })
                            }} />
                    }
                    {isSharing &&
                        <ShareContent hideSportLabel={false} style={{}} post={item} type={"POST"} user={this.props.user} userType={this.props.userType} isOpen={isSharing} onClose={() => {
                            this.setState({ isSharing: false })
                        }} />
                    }
                </LeagueSplitView>
            </div>
        );
    }
}

export class PostText extends React.Component {
    constructor(p) {
        super(p)
    }

    render() {
        return (
            <div ref={(ref) => this.elem = (ref === null) ? this.elem : ref} className={this.props.className} dangerouslySetInnerHTML={{ __html: this.props.text }}></div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/PostView.js